import React from 'react';
export var StepsContext = React.createContext({
    current: 0,
    labelPlacement: 'vertical',
    status: 'process',
    clickable: false,
});
//# sourceMappingURL=steps-context.js.map